export const getUniqueList = (list: any[]): any[] => {
  try {
    return [...new Set(list)];
  } catch {
    return [];
  }
};
